import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
export function Guarantee() {
  return <section className="w-full bg-ink-950 px-4 py-14 sm:py-20" data-id="element-129" data-mp="20mef3exz8k06">
      <div className="mx-auto max-w-2xl" data-id="element-130" data-mp="24molgspolcfk">
        <div className="rounded-3xl border border-arc-500/30 bg-ink-800/70 p-6 text-center sm:p-9" data-id="element-131" data-mp="24ln82hl70duo">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-arc-500/15" data-id="element-132" data-mp="29f807t03udly">
            <ShieldCheckIcon className="h-8 w-8 text-arc-400" aria-hidden="true" data-id="element-133" data-mp="2ecrm9f31nuog" />
          </span>
          <h2 className="mt-5 font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-134" data-mp="2ja9sgxpofvsr">
            Essayez-le pendant 7 jours sans risque
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-white/70" data-id="element-135" data-mp="2sbhplcggiql9">
            Votre achat est protégé par une garantie de satisfaction de 7 jours. Si vous
            consultez les Manuels, appliquez le système et pensez qu’il ne correspond pas à
            vos attentes, écrivez-nous simplement et nous vous rembourserons 100 % de votre
            paiement.
          </p>
          <ul className="mt-5 flex flex-col items-center gap-1.5 text-xs font-extrabold uppercase tracking-[0.15em] text-spark-400" data-id="element-136" data-mp="3ntotdz8zsnmi">
            <li data-id="element-137" data-mp="3ivwp05r5v91f">Sans questions.</li>
            <li data-id="element-138" data-mp="3dwshdjjvxjd7">Sans procédures compliquées.</li>
            <li data-id="element-139" data-mp="3dy3kri9f4p3s">Sans complications.</li>
          </ul>
          <p className="mt-5 text-base font-bold text-white" data-id="element-140" data-mp="femwdwuzhjfd">
            Vous ne prenez aucun risque. Nous le prenons à votre place.
          </p>
        </div>

        <div className="mt-9" data-id="element-141" data-mp="adqu1nqa65c2">
          <CtaBlock label="Essayer sans risque" data-id="element-142" data-mp="5ggvnikwyjc3" />
        </div>
      </div>
    </section>;
}